// This file maps state to stores, and also exposes a fetchData function to fetch all
// the data needed to render the smart component
import CommonStore from '@src/stores/CommonStore';
import ActionStore from '@src/ActionStore';
import BotSaysStore from '@src/stores/BotSaysStore';

/**
 * These are the stores the container will subscribe to, the getStateFromStores()
 * below runs again if the stores mentioned here emit a change
 * @type {Array}
 */
export const listenToStores = [CommonStore, ActionStore, BotSaysStore];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  return {
    domainName: CommonStore.getMetaTags().domain.title,
    entitiesOnNode: BotSaysStore.getEntitiesOnNode(),
  };
}

export { searchForEntities } from '@src/actions/EntityActions';
export { convertEntityCategory } from '@src/utils/NodeUtils';
